function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
/* eslint-disable jsx-a11y/label-has-associated-control */
import Cropper from 'cropperjs';
import { h, Component } from 'preact';
import getCanvasDataThatFitsPerfectlyIntoContainer from "./utils/getCanvasDataThatFitsPerfectlyIntoContainer.js";
import getScaleFactorThatRemovesDarkCorners from "./utils/getScaleFactorThatRemovesDarkCorners.js";
import limitCropboxMovementOnMove from "./utils/limitCropboxMovementOnMove.js";
import limitCropboxMovementOnResize from "./utils/limitCropboxMovementOnResize.js";
var Editor = /*#__PURE__*/function (_Component) {
  _inherits(Editor, _Component);
  function Editor(props) {
    var _this;
    _classCallCheck(this, Editor);
    _this = _callSuper(this, Editor, [props]);
    _this.onRotate90Deg = function () {
      // 1. Set state
      var angle90Deg = _this.state.angle90Deg;
      var newAngle = angle90Deg - 90;
      _this.setState({
        angle90Deg: newAngle,
        angleGranular: 0
      });

      // 2. Rotate the image
      // Important to reset scale here, or cropper will get confused on further rotations
      _this.cropper.scale(1);
      _this.cropper.rotateTo(newAngle);

      // 3. Fit the rotated image into the view
      var canvasData = _this.cropper.getCanvasData();
      var containerData = _this.cropper.getContainerData();
      var newCanvasData = getCanvasDataThatFitsPerfectlyIntoContainer(containerData, canvasData);
      _this.cropper.setCanvasData(newCanvasData);

      // 4. Make cropbox fully wrap the image
      _this.cropper.setCropBoxData(newCanvasData);
    };
    _this.onRotateGranular = function (ev) {
      // 1. Set state
      var newGranularAngle = Number(ev.target.value);
      _this.setState({
        angleGranular: newGranularAngle
      });

      // 2. Rotate the image
      var angle90Deg = _this.state.angle90Deg;
      var newAngle = angle90Deg + newGranularAngle;
      _this.cropper.rotateTo(newAngle);

      // 3. Scale the image so that it fits into the cropbox
      var image = _this.cropper.getImageData();
      var scaleFactor = getScaleFactorThatRemovesDarkCorners(image.naturalWidth, image.naturalHeight, newGranularAngle);
      // Preserve flip
      var scaleFactorX = _this.cropper.getImageData().scaleX < 0 ? -scaleFactor : scaleFactor;
      _this.cropper.scale(scaleFactorX, scaleFactor);
    };
    _this.state = {
      angle90Deg: 0,
      angleGranular: 0,
      prevCropboxData: null
    };
    _this.storePrevCropboxData = _this.storePrevCropboxData.bind(_assertThisInitialized(_this));
    _this.limitCropboxMovement = _this.limitCropboxMovement.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(Editor, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        opts = _this$props.opts,
        storeCropperInstance = _this$props.storeCropperInstance;
      this.cropper = new Cropper(this.imgElement, opts.cropperOptions);
      this.imgElement.addEventListener('cropstart', this.storePrevCropboxData);
      // @ts-expect-error custom cropper event but DOM API does not understand
      this.imgElement.addEventListener('cropend', this.limitCropboxMovement);
      storeCropperInstance(this.cropper);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.cropper.destroy();
      this.imgElement.removeEventListener('cropstart', this.storePrevCropboxData);
      // @ts-expect-error custom cropper event but DOM API does not understand
      this.imgElement.removeEventListener('cropend', this.limitCropboxMovement);
    }

    // eslint-disable-next-line react/sort-comp
  }, {
    key: "storePrevCropboxData",
    value: function storePrevCropboxData() {
      this.setState({
        prevCropboxData: this.cropper.getCropBoxData()
      });
    }
  }, {
    key: "limitCropboxMovement",
    value: function limitCropboxMovement(event) {
      var canvasData = this.cropper.getCanvasData();
      var cropboxData = this.cropper.getCropBoxData();
      var prevCropboxData = this.state.prevCropboxData;

      // 1. When we grab the cropbox in the middle and move it
      if (event.detail.action === 'all') {
        var newCropboxData = limitCropboxMovementOnMove(canvasData, cropboxData, prevCropboxData);
        if (newCropboxData) this.cropper.setCropBoxData(newCropboxData);
        // 2. When we stretch the cropbox by one of its sides
      } else {
        var _newCropboxData = limitCropboxMovementOnResize(canvasData, cropboxData, prevCropboxData);
        if (_newCropboxData) this.cropper.setCropBoxData(_newCropboxData);
      }
    }
  }, {
    key: "renderGranularRotate",
    value: function renderGranularRotate() {
      var i18n = this.props.i18n;
      var angleGranular = this.state.angleGranular;
      return h("label", {
        role: "tooltip",
        "aria-label": "".concat(angleGranular, "\xBA"),
        "data-microtip-position": "top",
        className: "uppy-ImageCropper-rangeWrapper"
      }, h("input", {
        className: "uppy-ImageCropper-range uppy-u-reset",
        type: "range",
        onInput: this.onRotateGranular,
        onChange: this.onRotateGranular,
        value: angleGranular,
        min: "-45",
        max: "45",
        "aria-label": i18n('rotate')
      }));
    }
  }, {
    key: "renderRevert",
    value: function renderRevert() {
      var _this2 = this;
      var _this$props2 = this.props,
        i18n = _this$props2.i18n,
        opts = _this$props2.opts;
      return h("button", {
        role: "button tooltip",
        "data-microtip-position": "top",
        type: "button",
        className: "uppy-u-reset uppy-c-btn",
        "aria-label": i18n('revert'),
        onClick: function onClick() {
          _this2.cropper.reset();
          _this2.cropper.setAspectRatio(opts.cropperOptions.initialAspectRatio);
          _this2.setState({
            angle90Deg: 0,
            angleGranular: 0
          });
        }
      }, h("svg", {
        "aria-hidden": "true",
        className: "uppy-c-icon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
      }, h("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      }), h("path", {
        d: "M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"
      })));
    }
  }, {
    key: "renderRotate",
    value: function renderRotate() {
      var i18n = this.props.i18n;
      return h("button", {
        role: "button tooltip",
        "data-microtip-position": "top",
        type: "button",
        className: "uppy-u-reset uppy-c-btn",
        "aria-label": i18n('rotate'),
        onClick: this.onRotate90Deg
      }, h("svg", {
        "aria-hidden": "true",
        className: "uppy-c-icon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
      }, h("path", {
        d: "M0 0h24v24H0V0zm0 0h24v24H0V0z",
        fill: "none"
      }), h("path", {
        d: "M14 10a2 2 0 012 2v7a2 2 0 01-2 2H6a2 2 0 01-2-2v-7a2 2 0 012-2h8zm0 1.75H6a.25.25 0 00-.243.193L5.75 12v7a.25.25 0 00.193.243L6 19.25h8a.25.25 0 00.243-.193L14.25 19v-7a.25.25 0 00-.193-.243L14 11.75zM12 .76V4c2.3 0 4.61.88 6.36 2.64a8.95 8.95 0 012.634 6.025L21 13a1 1 0 01-1.993.117L19 13h-.003a6.979 6.979 0 00-2.047-4.95 6.97 6.97 0 00-4.652-2.044L12 6v3.24L7.76 5 12 .76z"
      })));
    }
  }, {
    key: "renderFlip",
    value: function renderFlip() {
      var _this3 = this;
      var i18n = this.props.i18n;
      return h("button", {
        role: "button tooltip",
        "data-microtip-position": "top",
        type: "button",
        className: "uppy-u-reset uppy-c-btn",
        "aria-label": i18n('flipHorizontal'),
        onClick: function onClick() {
          return _this3.cropper.scaleX(-_this3.cropper.getData().scaleX || -1);
        }
      }, h("svg", {
        "aria-hidden": "true",
        className: "uppy-c-icon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
      }, h("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      }), h("path", {
        d: "M15 21h2v-2h-2v2zm4-12h2V7h-2v2zM3 5v14c0 1.1.9 2 2 2h4v-2H5V5h4V3H5c-1.1 0-2 .9-2 2zm16-2v2h2c0-1.1-.9-2-2-2zm-8 20h2V1h-2v22zm8-6h2v-2h-2v2zM15 5h2V3h-2v2zm4 8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2z"
      })));
    }
  }, {
    key: "renderZoomIn",
    value: function renderZoomIn() {
      var _this4 = this;
      var i18n = this.props.i18n;
      return h("button", {
        role: "button tooltip",
        "data-microtip-position": "top",
        type: "button",
        className: "uppy-u-reset uppy-c-btn",
        "aria-label": i18n('zoomIn'),
        onClick: function onClick() {
          return _this4.cropper.zoom(0.1);
        }
      }, h("svg", {
        "aria-hidden": "true",
        className: "uppy-c-icon",
        height: "24",
        viewBox: "0 0 24 24",
        width: "24"
      }, h("path", {
        d: "M0 0h24v24H0V0z",
        fill: "none"
      }), h("path", {
        d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
      }), h("path", {
        d: "M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z"
      })));
    }
  }, {
    key: "renderZoomOut",
    value: function renderZoomOut() {
      var _this5 = this;
      var i18n = this.props.i18n;
      return h("button", {
        role: "button tooltip",
        "data-microtip-position": "top",
        type: "button",
        className: "uppy-u-reset uppy-c-btn",
        "aria-label": i18n('zoomOut'),
        onClick: function onClick() {
          return _this5.cropper.zoom(-0.1);
        }
      }, h("svg", {
        "aria-hidden": "true",
        className: "uppy-c-icon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
      }, h("path", {
        d: "M0 0h24v24H0V0z",
        fill: "none"
      }), h("path", {
        d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zM7 9h5v1H7z"
      })));
    }
  }, {
    key: "renderCropSquare",
    value: function renderCropSquare() {
      var _this6 = this;
      var i18n = this.props.i18n;
      return h("button", {
        role: "button tooltip",
        "data-microtip-position": "top",
        type: "button",
        className: "uppy-u-reset uppy-c-btn",
        "aria-label": i18n('aspectRatioSquare'),
        onClick: function onClick() {
          return _this6.cropper.setAspectRatio(1);
        }
      }, h("svg", {
        "aria-hidden": "true",
        className: "uppy-c-icon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
      }, h("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      }), h("path", {
        d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
      })));
    }
  }, {
    key: "renderCropWidescreen",
    value: function renderCropWidescreen() {
      var _this7 = this;
      var i18n = this.props.i18n;
      return h("button", {
        role: "button tooltip",
        "data-microtip-position": "top",
        type: "button",
        className: "uppy-u-reset uppy-c-btn",
        "aria-label": i18n('aspectRatioLandscape'),
        onClick: function onClick() {
          return _this7.cropper.setAspectRatio(16 / 9);
        }
      }, h("svg", {
        "aria-hidden": "true",
        className: "uppy-c-icon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
      }, h("path", {
        d: "M 19,4.9999992 V 17.000001 H 4.9999998 V 6.9999992 H 19 m 0,-2 H 4.9999998 c -1.0999999,0 -1.9999999,0.9000001 -1.9999999,2 V 17.000001 c 0,1.1 0.9,2 1.9999999,2 H 19 c 1.1,0 2,-0.9 2,-2 V 6.9999992 c 0,-1.0999999 -0.9,-2 -2,-2 z"
      }), h("path", {
        fill: "none",
        d: "M0 0h24v24H0z"
      })));
    }
  }, {
    key: "renderCropWidescreenVertical",
    value: function renderCropWidescreenVertical() {
      var _this8 = this;
      var i18n = this.props.i18n;
      return h("button", {
        role: "button tooltip",
        "data-microtip-position": "top",
        type: "button",
        "aria-label": i18n('aspectRatioPortrait'),
        className: "uppy-u-reset uppy-c-btn",
        onClick: function onClick() {
          return _this8.cropper.setAspectRatio(9 / 16);
        }
      }, h("svg", {
        "aria-hidden": "true",
        className: "uppy-c-icon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
      }, h("path", {
        d: "M 19.000001,19 H 6.999999 V 5 h 10.000002 v 14 m 2,0 V 5 c 0,-1.0999999 -0.9,-1.9999999 -2,-1.9999999 H 6.999999 c -1.1,0 -2,0.9 -2,1.9999999 v 14 c 0,1.1 0.9,2 2,2 h 10.000002 c 1.1,0 2,-0.9 2,-2 z"
      }), h("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this9 = this;
      var _this$props3 = this.props,
        currentImage = _this$props3.currentImage,
        opts = _this$props3.opts;
      var actions = opts.actions;
      var imageURL = URL.createObjectURL(currentImage.data);
      return h("div", {
        className: "uppy-ImageCropper"
      }, h("div", {
        className: "uppy-ImageCropper-container"
      }, h("img", {
        className: "uppy-ImageCropper-image",
        alt: currentImage.name,
        src: imageURL,
        ref: function ref(_ref) {
          _this9.imgElement = _ref;
        }
      })), h("div", {
        className: "uppy-ImageCropper-controls"
      }, actions.revert && this.renderRevert(), actions.rotate && this.renderRotate(), actions.granularRotate && this.renderGranularRotate(), actions.flip && this.renderFlip(), actions.zoomIn && this.renderZoomIn(), actions.zoomOut && this.renderZoomOut(), actions.cropSquare && this.renderCropSquare(), actions.cropWidescreen && this.renderCropWidescreen(), actions.cropWidescreenVertical && this.renderCropWidescreenVertical()));
    }
  }]);
  return Editor;
}(Component);
export { Editor as default };